import React from 'react';
import { View, ActivityIndicator, Text, StyleSheet, ViewStyle } from 'react-native';
import { useTheme, SPACING, TYPOGRAPHY } from '../../theme';

interface LoadingSpinnerProps {
  size?: 'small' | 'large';
  message?: string;
  fullScreen?: boolean;
  style?: ViewStyle;
  color?: string;
}

export function LoadingSpinner({
  size = 'large',
  message,
  fullScreen = false,
  style,
  color,
}: LoadingSpinnerProps) {
  const { colors } = useTheme();

  // testID on every instance: the visual audit refuses to photograph a screen
  // while one of these is mounted. Six screens share this component and none
  // of them had a data-ready wait, so "Loading post…", "Loading property…"
  // and "Loading comments…" were all reaching baselines.
  const spinner = (
    <View
      testID="loading-spinner"
      style={[styles.container, fullScreen && styles.fullScreen, style]}>
      <ActivityIndicator size={size} color={color || colors.primary} />
      {message && <Text style={[styles.message, { color: colors.textSecondary }]}>{message}</Text>}
    </View>
  );

  if (fullScreen) {
    return (
      <View style={[styles.fullScreenOverlay, { backgroundColor: colors.background }]}>
        {spinner}
      </View>
    );
  }

  return spinner;
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: SPACING.lg,
  },
  fullScreen: {
    flex: 1,
  },
  fullScreenOverlay: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
    justifyContent: 'center',
  },
  message: {
    ...TYPOGRAPHY.body,
    marginTop: SPACING.md,
    textAlign: 'center',
  },
});
